/*
 *   File : add-sub-admin.js
 *   Author : https://evoqins.com
 *   Description : Add sub admin modal component
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// custom components
import { CustomSelectBox, CustomTextInput } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { APIService } from '../../Service';

// custom style
import Color from "../../Style/color.scss";
import style from '../../Style/Component/add-sub-admin.module.scss';

const ROLE_DATA = [
    {
        id: 1,
        label: 'Sample 1',
        value: 'Sample 1',
    },
    {
        id: 2,
        label: 'Sample 2',
        value: 'Sample 2',
    },
    {
        id: 3,
        label: 'Sample',
        value: 'Sample 3'
    },
    {
        id: 4,
        label: 'Sample',
        value: 'Sample'
    }
];

const AddSubAdminModal = (props) => {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [number, setNumber] = useState("");
    const [numberError, setNumberError] = useState("");
    const [selectedRoleError, setSelectedRoleError] = useState("");
    const [selectedManagerError, setSelectedManagerError] = useState("");
    const [roleList, setRoleList] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedManager, setSelectedManager] = useState(null);

    const [success, setSuccess] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        _getRoles();
    }, [])


    useEffect(() => {
        setSuccess(false);

    }, []);

    useEffect(() => {
        setNameError("");
    }, [name]);

    useEffect(() => {
        setEmailError("");
    }, [email]);

    useEffect(() => {
        setNumberError("");
    }, [number]);

    useEffect(() => {
        setSelectedRoleError("");
    }, [selectedRole]);

    useEffect(() => {
        setSelectedManagerError("");
    }, [selectedManager]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("add-sub-admin-modal-close");
        button.click();
        props.handleClose();

    };



    // handle send email
    const _handleInvite = () => {
        let is_valid = true;
        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_number = /^[6-9]\d{9}$/;

        if (name.trim().length === 0) {
            setNameError("Please provide name");
            is_valid = false;
        }

        if (email.trim().length === 0) {
            setEmailError("Please provide email");
            is_valid = false;
        } else if (!validate_email.test(email)) {
            setEmailError("Please provide a valid email");
            is_valid = false;
        }

        // if (number.trim().length === 0) {
        //     setNumberError("Please provide phone number");
        //     is_valid = false;
        // } else if (!validate_number.test(number)) {
        //     setNumberError("Please provide a valid number");
        //     is_valid = false;
        // }

        if (selectedRole === null) {
            setSelectedRoleError("Please select role");
            is_valid = false;
        }
        if (selectedManager === null) {
            setSelectedManagerError("Please select manager");
            is_valid = false;
        }

        if (is_valid === true) {
            _addSubAdmin();
        }
    };


    const _getRoles = () => {
        let is_post = true;
        let url = 'sub-admin/role/list';
        let request = {
            "page_num": 1,
            "page_size": 20,
            "is_active": true,
            "query": ""
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                // setSubAdmins(response.data);
                const admins = response.data.data.map((admin) => ({
                    label: admin.name,
                    value: admin.id
                }));
                setRoleList(admins);
            } else {
                setRoleList([]);
            }
            // setListLoader(false);
        })
    }

    // API - add sub admin
    const _addSubAdmin = () => {
        let is_post = true;
        let url = 'sub-admin/add-admin';
        let request = {
            "admin_type": selectedRole.value,
            "username": name,
            "email": email,
            // "mobile_number": number,
            "reporting_manager": selectedManager.value
        }
        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSuccess(true);
            }
            else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setLoader(false);
        })
    };



    return (
        <div className="modal fade"
            id="add-sub-admin-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="addSubAdminModalLabel"
            aria-hidden="true">

            <div className={`${success ? 'modal-md' : 'modal-lg'} modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='add-sub-admin-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {success ? 'Success!' : 'Add sub admin'}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                        {success ?
                            <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                The invitation email has been successfully sent to <span className='e-font-weight-600'>{email}</span>. They can now proceed with the account setup and complete their signup.
                            </p>
                            :
                            <>
                                <div className='row pb-4'>
                                    {/* Name */}
                                    <div className='col-6'>
                                        <CustomTextInput label="Name"
                                            placeholder="Enter name"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={name}
                                            error={nameError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleInvite}
                                            handleChange={(e) => setName(e)} />
                                    </div>

                                    {/* Email */}
                                    <div className='col-6'>
                                        <CustomTextInput label="Email"
                                            placeholder="Enter email"
                                            type="text"
                                            required={true}
                                            value={email}
                                            error={emailError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleInvite}
                                            handleChange={(e) => setEmail(e)} />
                                    </div>
                                </div>

                                <div className='row pb-4'>
                                    {/* Phone number */}


                                    {/* Role */}
                                    <div className='col-6'>
                                        <CustomSelectBox title='Role'
                                            placeholder='Select role'
                                            controlWidth='w-100'
                                            required={true}
                                            options={roleList}
                                            // isMulti={true}
                                            isSearchable={true}
                                            borderColor={`0.031rem solid ${Color.arsenic}`}
                                            padding="0.5rem 1rem"
                                            value={selectedRole}
                                            error={selectedRoleError}
                                            onChange={(data) => setSelectedRole(data)} />
                                    </div>

                                    <div className='col-6  '>
                                        <CustomSelectBox title='Reporting manager'
                                            placeholder='Enter reporting manager'
                                            controlWidth='w-100'
                                            required={true}
                                            options={props.admins}
                                            isSearchable={true}
                                            borderColor={`0.031rem solid ${Color.arsenic}`}
                                            padding="0.5rem 1rem"
                                            value={selectedManager}
                                            error={selectedManagerError}
                                            onChange={(data) => setSelectedManager(data)} />
                                    </div>
                                </div>

                              

                        <div className='mt-2 e-bg-magnolia-light p-3 border-radius-8 d-flex gap-1 align-items-start'>
                            <Icon icon="info"
                                size="1rem"
                                color={Color.davys_grey_light}
                                className="d-flex" />

                            <p className='mb-0 e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                An invitation email will be sent to the provided email address, allowing the recipient to complete the account setup and signup process.
                            </p>
                        </div>
                    </>
                        }
                </div>

                {/* Modal footer */}
                <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                    {success ?
                        <SecondaryButton name="Ok"
                            className="py-3 padding-54px-lr "
                            onClick={_handleCloseModal} />
                        :
                        <>
                            <SecondaryButton name="Cancel"
                                className="py-3 padding-54px-lr"
                                onClick={_handleCloseModal} />
                            <PrimaryButton name="Send Invitation"
                                className={`${loader ? 'w-172px' : ''} padding-40px-lr`}
                                loader={loader}
                                onClick={_handleInvite} />
                        </>
                    }
                </div>
            </div>
        </div>
        </div >
    )
}

export default AddSubAdminModal;

AddSubAdminModal.defaultProps = {
    handleClose: () => { }
};